module.exports = __webpack_public_path__ + "static/img/050微心愿.4bc97ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/050微心愿.jpg
// module id = Qz0H
// module chunks = 0